import React from 'react';
import PropTypes from 'prop-types';

import { Select } from '@metarouter-private/mr-mui';
import WithTooltip from 'app/components/WithTooltip';

import { useBulkDeployPageContext } from 'ion-experimental/app/bulk-deploy/BulkDeployPageContext';

export default function RevisionSelect({ disabled }) {
  const {
    selectedIntegration,
    selectedRevision,
    revisionsByIntegrationId,
    handleRevisionChange,
    revisionSelectDisabled,
    revisionSelectDisabledMessage,
  } = useBulkDeployPageContext();

  const handleChange = ({ target }) => {
    handleRevisionChange({ value: target.value });
  };

  const isDisabled = disabled || revisionSelectDisabled;
  const revisionOptions = revisionsByIntegrationId[selectedIntegration] || [];

  return (
    <WithTooltip show={Boolean(revisionSelectDisabledMessage)} title={revisionSelectDisabledMessage}>
      <Select
        label="Revision"
        size="small"
        variant="outlined"
        key={`${selectedIntegration}-revision-select`}
        value={selectedRevision}
        options={revisionOptions}
        onChange={handleChange}
        disabled={isDisabled}
        data-test-id="revisionSelect"
      />
    </WithTooltip>
  );
}

RevisionSelect.propTypes = {
  disabled: PropTypes.bool,
};
